import PropTypes from 'prop-types';
import Area from 'components/Area';
import FormattedDate from 'components/FormattedDate';
import Optional from 'components/Optional';
import SalePrice from 'components/SalePrice';
import './TargetPropertyAttributes.scss';
import bathIcon from 'images/bath.svg';
import bedIcon from 'images/bed.svg';
import carIcon from 'images/car.svg';
import landIcon from 'images/land.svg';
import floorIcon from 'images/floor.svg';
import { titleCase } from 'lib/StringUtils';
import { isNZLocale, isVIC } from 'lib/PropertyUtils';
import DataUpdateContainer from 'components/DataUpdate';

TargetPropertyAttributes.propTypes = {
    detail: PropTypes.shape({
        propertyId: PropTypes.number,
        bathrooms: PropTypes.number,
        bedrooms: PropTypes.number,
        carSpaces: PropTypes.number,
        floorArea: PropTypes.number,
        isPriceWithheld: PropTypes.bool,
        isAgentsAdvice: PropTypes.bool,
        landArea: PropTypes.number,
        lastSoldPrice: PropTypes.node,
        owners: PropTypes.arrayOf(PropTypes.string.isRequired),
        propertyType: PropTypes.string,
        singleLineAddress: PropTypes.string,
        saleDate: PropTypes.string,
        yearBuilt: PropTypes.number,
        salePrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }).isRequired,
    hideOwnerNamesForVic: PropTypes.bool,
    pageContext: PropTypes.string,
};

export default function TargetPropertyAttributes({detail, hideOwnerNamesForVic, pageContext}) {
    const hideOwner = isVIC(detail.singleLineAddress) && hideOwnerNamesForVic;
    return (
        <div className="TargetPropertyAttributes">
            <div className="bbc">
                <div className="bedrooms"><img className="icon" src={bedIcon} alt="bedrooms"/><Optional
                    value={detail.bedrooms}/></div>
                <div className="bathrooms"><img className="icon" src={bathIcon} alt="bathrooms"/><Optional
                    value={detail.bathrooms}/></div>
                <div className="car-spaces"><img className="icon" src={carIcon} alt="car spaces"/><Optional
                    value={detail.carSpaces}/></div>
                <div className="land-area"><img className="icon" src={landIcon} alt="land area"/><Area
                    area={detail.landArea}/></div>
                <div className="floor-area"><img className="icon" src={floorIcon} alt="floor area"/><Area
                    area={detail.floorArea}/></div>
                <DataUpdateContainer pageContext={pageContext}
                                     propertyContext="Target Property"
                                     propertyId={detail.propertyId}
                                     disabled={!detail?.singleLineAddress}/>
            </div>
            <div className="details">
                <div className="property-type">
                    <label>Property Type</label>
                    <span><Optional value={detail.propertyType && titleCase(detail.propertyType)}/></span>
                </div>
                <div className="last-sold">
                    <label>Last Sold</label>
                    <SalePrice salePrice={detail.salePrice}
                               isAgentsAdvice={detail.isAgentsAdvice}
                               isPriceWithheld={detail.isPriceWithheld}
                    />
                </div>
                <div className="sold-date">
                    <label>Sold Date</label>
                    <FormattedDate date={detail.saleDate} format="D MMM YYYY"/>
                </div>
                <div className="year-built">
                    <label>{isNZLocale() ? 'Age' : 'Year Built'}</label>
                    <Optional value={detail.yearBuilt}/>
                </div>
                {!hideOwner && (
                    <div className="owner">
                        <label>Owner Name</label>
                        <Optional value={detail.owners && detail.owners.join(', ')}/>
                    </div>
                )}
            </div>
        </div>
    );
}
